export const linkStyle = {color:"#FF6F0F",cursor:'pointer', textAlign: "right",margin:"0 5px"}